import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
  },
  appBarTitle: {
    flexGrow: 1,
    fontWeight: 600,
    letterSpacing: '0.05rem',
  },
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(6),
  },
  pageTitle: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: '1.25rem',
    marginBottom: theme.spacing(2),
  },
  salonInfoBox: {
    marginBottom: theme.spacing(3),
  },
  salonName: {
    fontWeight: 700,
    fontSize: '1rem',
    marginBottom: theme.spacing(0.5),
  },
  branchName: {
    fontSize: '0.875rem',
    color: 'rgba(0,0,0,0.87)',
    marginBottom: theme.spacing(0.5),
  },
  courseName: {
    fontSize: '0.9rem',
    marginTop: theme.spacing(1),
  },
  dateTimeRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
    fontSize: '0.9rem',
  },
  dateTimeLabel: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
  divider: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '0.9rem',
    marginBottom: theme.spacing(1.5),
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    paddingBottom: theme.spacing(0.5),
  },
  reserverBox: {
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  reserverRow: {
    display: 'flex',
    marginBottom: theme.spacing(0.5),
    fontSize: '0.875rem',
  },
  reserverLabel: {
    width: '5rem',
    color: 'rgba(0,0,0,0.87)',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  reserverValue: {
    fontWeight: 500,
  },
  cautionBox: {
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    whiteSpace: 'pre-line',
    fontSize: '0.8rem',
    lineHeight: 1.7,
    color: 'rgba(0,0,0,0.87)',
  },
  checkItemsBox: {
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  checkItem: {
    fontSize: '0.8rem',
    lineHeight: 1.7,
    color: 'rgba(0,0,0,0.87)',
    marginBottom: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'flex-start',
  },
  checkBullet: {
    marginRight: theme.spacing(1),
    marginTop: '0.15rem',
    flexShrink: 0,
    color: theme.palette.primary.main,
  },
  changeSection: {
    marginTop: theme.spacing(2),
  },
  changeSectionTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  actionButton: {
    marginBottom: theme.spacing(1.5),
    borderRadius: 30,
    padding: theme.spacing(1.5),
    fontSize: '1rem',
    fontWeight: 600,
  },
  cancelLink: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
    textAlign: 'center',
    display: 'block',
    marginTop: theme.spacing(1),
    fontSize: '0.9rem',
  },
}));

export default useStyles;
